var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 1.04602C11.503 1.10986 11.6803 1.2368 11.8062 1.40837C11.9321 1.57995 12 1.78721 12 2.00002V7.00002H16C16.1829 6.99994 16.3623 7.05003 16.5187 7.14484C16.6752 7.23965 16.8026 7.37556 16.8871 7.53776C16.9717 7.69996 17.0101 7.88225 16.9983 8.06478C16.9865 8.24732 16.9248 8.4231 16.82 8.57302L9.81996 18.573C9.69813 18.7476 9.52379 18.8787 9.3223 18.9473C9.12081 19.0159 8.90268 19.0184 8.69965 18.9545C8.49663 18.8906 8.31929 18.7635 8.19345 18.5919C8.06761 18.4202 7.99982 18.2129 7.99996 18V13H3.99996C3.81704 13.0001 3.6376 12.95 3.48117 12.8552C3.32475 12.7604 3.19732 12.6245 3.11277 12.4623C3.02821 12.3001 2.98976 12.1178 3.00161 11.9353C3.01346 11.7527 3.07514 11.5769 3.17996 11.427L10.18 1.42702C10.302 1.2528 10.4763 1.12203 10.6778 1.05369C10.8792 0.985356 11.0971 0.983018 11.3 1.04702V1.04602Z",
    fill: "#FEBA64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.a6991547a4a1c8426cfe9141bdfc665b.svg";
export { ForwardRef as ReactComponent };